<template>
  <div class="dealers-list">
    <top-bar
      title="Evaluaciones"
      :show-add-button="$store.getters['profile/can']('evaluations.store')"
      add-button-label="Agregar evaluación"
      @addItem="onAddEvaluation"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        >
          <star-rating
            slot-scope="{row}"
            slot="stars"
            :score="row.stars"
          />
          <span
            slot-scope="{row}"
            slot="timeStatus"
            class="status"
            :class="row.timeStatus"
          >
            {{ row.timeStatus | status }}
          </span>
        </ms-grid>
      </div>
    </scrollable-container>
    <branch-evaluation-form
      :branch-id="branch.id"
      @closeModal="onCloseEvaluationForm"
      @onSave="onEvaluationAdded"
      v-if="showBranchEvaluationForm"
    />
    <router-view/>
  </div>
</template>

<script>
import DefaultGuards from '@/guards/default.guards'
import DefaultActions from '@/helpers/default-actions'
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import statusFilter from '@/filters/status.filter'
import { mapGetters } from 'vuex'
import moment from 'moment'
import http from '@/services/http.service'
import BranchEvaluationForm from '@/modules/branches/branch-evaluation-form'

export default {
  name: 'DealerList',
  filters: {
    status: statusFilter
  },
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid,
    BranchEvaluationForm
  },
  data () {
    return {
      showBranchEvaluationForm: false,
      columns: [
        {
          label: 'Evaluación',
          property: 'layout.name',
          sortable: false,
          link: row => {
            if (this.canSolveEvaluation) {
              return { name: 'evaluation', params: { id: row.id } }
            } else if (row.status.completed) {
              return { name: 'evaluation-result', params: { id: row.id } }
            } else {
              return false
            }
          }
        },
        {
          label: 'Departamento',
          property: 'division'
        },
        {
          label: 'Sucursal',
          property: 'branch.name',
          filter (value, row) {
            if (row.branch) {
              let branchName = row.branch.municipality + ', ' + row.branch.state
              if (row.branch.name) {
                branchName += '(' + row.branch.name + ')'
              }
              return branchName
            }
          }
        },
        {
          label: 'Periodo',
          property: 'period.name',
          sortable: false
        },
        {
          label: 'Estatus',
          property: 'status',
          filter: statusFilter,
          align: 'center'
        },
        {
          label: 'Tiempo',
          property: 'timeStatus',
          align: 'center'
        },
        {
          label: 'Inicio',
          property: 'startDate',
          type: 'date',
          align: 'center'
        },
        {
          label: 'Fin',
          property: 'endDate',
          type: 'date',
          align: 'center'
        },
        {
          label: 'Calificación',
          property: 'stars',
          align: 'center'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Consultar',
            icon: 'icon-eye',
            show: row => {
              return row.status === 'complete'
            },
            onClick: row => {
              this.$router.push({
                name: 'evaluation-viewer',
                params: { id: row.id }
              })
            }
          },
          {
            label: 'Resolver',
            icon: 'icon-edit',
            show: () => {
              return this.$store.getters['profile/can']('evaluations.update')
            },
            onClick: row => {
              if (row.timeStatus !== 'inactive') {
                this.$router.push({
                  name: 'evaluation',
                  params: { id: row.id }
                })
              } else {
                this.$alert(
                  'Esta evaluacion podrá ser resuelta hasta el ' +
                    moment(row.assignment.startDate).format('LL'),
                  'Evaluación programada'
                )
              }
            }
          },
          {
            label: 'Restaurar',
            icon: 'icon-edit',
            show: row => {
              return (
                row.status === 'complete' &&
                this.$store.getters['profile/can']('evaluations.update')
              )
            },
            onClick: row => {
              http.put('evaluations/reset/' + row.id).then(function (response) {
                console.log(response)
              })
            }
          },
          DefaultActions.delete('evaluations')
        ]
      }
    }
  },
  computed: {
    ...mapGetters('evaluations', {
      items: 'items',
      pager: 'pagination'
    })
  },
  methods: {
    onAddEvaluation () {
      this.showBranchEvaluationForm = true
    }
  },
  beforeRouteEnter: DefaultGuards.onQuery('evaluations', {
    sort: 'id ASC',
    with: 'period, branch, layout, assignment'
  }),
  beforeRouteUpdate: DefaultGuards.onQuery('evaluations', {
    sort: 'id ASC',
    with: 'period, branch, layout, assignment'
  })
}
</script>

<style lang="scss" scoped>
.status {
  display: inline-block;
  background-color: dodgerblue;
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 2px;
  &.inactive {
    background-color: #cdcdcd;
    color: #999999;
  }
  &.active {
    background-color: #0083ca;
  }
  &.on_time {
    background-color: #60a50a;
  }
  &.out_of_time {
    background-color: #da3300;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/evaluations/evaluations-list.view.vue